module.exports = __webpack_public_path__ + "static/WW_1920x900-tablet.46b52a5a.jpg";